module.exports = __webpack_public_path__ + "static/media/band.566ceb0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/assets/band.png
// module id = 830
// module chunks = 0